import { Button, CircularProgress } from '@mui/material';

/**
 * Standardized form submit button with loading state
 *
 * @param {Object} props - Component props
 * @param {string} props.label - Button label when not loading
 * @param {boolean} props.loading - Whether the form is loading/submitting
 * @param {boolean} props.disabled - Additional disabled state
 * @param {string} props.variant - MUI button variant (default: 'contained')
 * @param {string} props.color - MUI button color (default: 'primary')
 * @param {boolean} props.fullWidth - Whether button is full width (default: true)
 * @param {Object} props.sx - Additional styles
 */
const FormSubmitButton = ({
  label,
  loading = false,
  disabled = false,
  variant = 'contained',
  color = 'primary',
  fullWidth = true,
  sx,
  children,
  ...rest
}) => {
  return (
    <Button
      type="submit"
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      disabled={loading || disabled}
      sx={{
        mt: 2,
        mb: 1,
        minHeight: 42,
        ...sx,
      }}
      {...rest}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : (children || label)}
    </Button>
  );
};

export default FormSubmitButton;
